import { ca } from '@cian/analytics';

interface IParameters {
  query: string;
  totalSuggest: string;
  url: string;
  isDuplicateSuggest: boolean;
}

export function trackSearchSubmit({ query, totalSuggest, url, isDuplicateSuggest }: IParameters) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'search_string',
    action: 'click',
    label: url,
    page: {
      extra: {
        clickType: 'button',
        searchQuery: query,
        suggestCount: totalSuggest,
        isDuplicateSuggest: isDuplicateSuggest.toString(),
      },
    },
  });
}
